import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ObsPipe } from '../../../pipes/obs.pipe';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { ObsStatutPipe } from '../../../pipes/obs-statut.pipe';

@Component({
  selector: 'app-traitement-data-obs',
  standalone: true,
  imports: [
    TraitementDataComponent,
    ObsPipe,
    ObsStatutPipe,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-obs.component.html',
  styleUrl: './traitement-data-obs.component.scss',
})
export class TraitementDataObsComponent {
  @Input() patient: Patient | undefined;
  @Input() activite: String | undefined;
}
